import React from 'react';
import Footer from './components/Footer';
import ProjectsList from './components/ProjectsList';
import './projects.css';
function Projects() {
    return (
        <div>
            <div className="wholeContainer">
                <div className="containerDetails">
                    <ProjectsList />
                    <Footer />
                </div>
            </div>
        </div>

    );
}
export default Projects;